import { gql } from '@apollo/client';
export const getDeliverablesdataApi = gql`
	query ExampleQuery($workspaceId: String, $filters: DeliverablesListFiltersInput) {
		vendorDeliverablesList(workspaceId: $workspaceId, filters: $filters) {
			currentPage
			data {
				id
				quantity
				priority
				updatedAt
				updatedBy
				status
				projectTitle
				slNo
				tenantId
				dueDate
				projectId
				cost
				createdAt
				createdBy
				notes {
					_id
					message
					files
					createdBy
					createdAt
					updatedBy
					updatedAt
				}
				assignedTo {
					id
					name
				}
				title
			}
			totalPages
			totalDocs
		}
	}
`;

export const getVendorDetailsApi = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
		vendorUsers {
			lastName
			firstName
			id
			displayName
		}
	}
`;

export const getAllProjectsApi = gql`
	query VendorsProjects($filters: projectsListFiltersInput) {
		vendorsProjects(filters: $filters) {
			data {
				title
				id
			}
			totalPages
		}
	}
`;

export const getfiltersCountApi = gql`
	query DeliverableDefaultFilters($tenantIds: [ID]) {
		deliverableDefaultFilters(tenantIds: $tenantIds) {
			all
			unassigned
			unscheduled
			overdue
			statusFilters {
				status
				count
			}
		}
	}
`;

export const getTenantUsers = gql`
	query TenantUsersList($workspaceIds: [String!]!, $userIds: [ID!]) {
		tenantUsersList(workspaceIds: $workspaceIds, userIds: $userIds) {
			id
			firstName
			lastName
			displayName
			phoneNumber
		}
	}
`;
export const getProjectListCorresWorkspaceApi = gql`
	query VendorsProjects($workspaceIds: [String!], $filters: projectsListFiltersInput) {
		vendorsProjects(workspaceIds: $workspaceIds, filters: $filters) {
			data {
				id
				title
			}
		}
	}
`;

export const craeteDeliverable = gql`
	mutation AddDeliverable(
		$workspaceId: String!
		$projectId: ID!
		$deliverableInput: DeliverableInput
	) {
		addDeliverable(
			workspaceId: $workspaceId
			projectId: $projectId
			deliverableInput: $deliverableInput
		) {
			assignedTo {
				id
				name
			}
			createdAt
			createdBy
		}
	}
`;

export const updateDeliverableApi = gql`
	mutation UpdateDeliverable(
		$workspaceId: String!
		$projectId: ID!
		$updateDeliverableId: ID!
		$deliverableInput: DeliverableInput
	) {
		updateDeliverable(
			workspaceId: $workspaceId
			projectId: $projectId
			id: $updateDeliverableId
			deliverableInput: $deliverableInput
		) {
			assignedTo {
				id
				name
			}
			status
		}
	}
`;
